import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Payment, Transaction } from './../../models';
import { AuthService } from './../../services/auth.service';
import { PseAvTransaction } from './../../models/pseav-transaction';
import { environment } from './../../../environments/environment';
import * as crypto from 'crypto-js';
import { TokenServiceService } from '../../services/token-service.service';
import { createMerchantReturnUrl } from 'src/app/shared/helps/helps';

@Component({
    selector: 'app-pse-av',
    templateUrl: './pse-av.component.html',
    styleUrls: ['./pse-av.component.scss'],
})
export class PseAvComponent implements OnInit {
    @Input() info: Payment;
    @Output() AV = new EventEmitter();

    orderID: string;
    amout;
    hash;
    url;
    pseavTransaction: PseAvTransaction;
    transaction: Transaction;
    urlReturnMerchant: string;
    template: string;

    constructor(private readonly authService: AuthService, private readonly tokenServiceService: TokenServiceService) { }

    ngOnInit() {
        this.onActivate();
        this.template = this.info.template;
        this.orderID = this.authService.getOrderID();
        this.pseavTransaction = new PseAvTransaction();
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.urlReturnMerchant = createMerchantReturnUrl(this.orderID, this.transaction.MERCHANT_URL_RETURN);
        this.amout = Number(this.transaction.ORDER_AMOUT.replace(',', '').replace('.00', ''));

        this.url = environment.host + 'checkout/alertpse';
        const data = {
            convenioId: this.info.concept[0].number,
            transaccionConvenioId: String(this.transaction.ORDER_CODE),
            referenciaPago1: this.transaction.ORDER_REFERENCE,
            descripcion: this.transaction.ORDER_BRIEF,
            valor: this.amout,
            urlRespuesta: this.url,
        };
        this.pseavTransaction.hash = this.setHash(data, environment.avvillas);
        this.pseavTransaction.convenioId = this.info.concept[0].number;
        this.pseavTransaction.transaccionConvenioId = String(this.transaction.ORDER_CODE);
        this.pseavTransaction.referenciaPago1 = this.transaction.ORDER_REFERENCE;
        this.pseavTransaction.descripcion = this.transaction.ORDER_BRIEF;
        this.pseavTransaction.valor = this.amout;
        this.pseavTransaction.urlRespuesta = this.url;
    }

    cifrar(texto, claveHttps) {
        const hash = crypto.HmacSHA256(texto, claveHttps);
        return crypto.enc.Base64.stringify(hash);
    }
    setHash(reg, claveHttps) {
        const texto = [
            reg.convenioId,
            reg.transaccionConvenioId || '',
            reg.referenciaPago1,
            reg.referenciaPago2 || '',
            reg.referenciaPago3 || '',
            reg.referenciaPago4 || '',
            reg.valor || '',
            reg.urlRespuesta,
        ].join('-');
        reg.hash = this.cifrar(texto, claveHttps);
        return reg.hash;
    }

    getHashConsulta(reg, claveHttps) {
        const texto = [reg.convenioId, reg.transaccionConvenioId || ''].join('-');
        return this.cifrar(texto, claveHttps);
    }

    validData(form: any) {
        form.submit();
    }

    changeMethod() {
        this.AV.emit();
    }

    onActivate() {
        window.scroll(0, 0);
    }
}
